
/**
 * Mega menu with images
 */
class MegaMenuImages {
	constructor() {
		this.init();
	}

	init() {
		$ = jQuery;
		var $megaMenu = $('.mega-menu.thumbnails');
		var $topMenuLinks = $megaMenu.find('.dropdown-toggle');
		var $megaMenuLinks = $megaMenu.find('.dropdown-menu a');

		$topMenuLinks.each(function(index) {
			var $this = $(this);

			$this.data('href', $this.attr('href'));
			//$this.removeAttr('href');
		});

		$megaMenuLinks.on('click', function(e) {
			var $this = $(this);
			var $parentMenuItem = $this.parent().parent();
			var $subMenu = $this.next('.dropdown-menu');
			var subMenuHtml = $subMenu.prop('outerHTML');
			var parentMenuItemText = $parentMenuItem.parent().children('.dropdown-toggle').text();
			var parentMenuItemTag = $parentMenuItem.parent().prop('tagName').toLowerCase();
			var currentMenuItemText = $this.children('span').text();

			if (parentMenuItemTag != 'div' && $(window).width() >= 768) {
				$parentMenuItem.parent().append('<div class="menu-item-header position-absolute left-0 w-100 justify-content-between align-items-center text-uppercase text-white"><div class="close-submenu d-flex align-items-center"><svg class="svg-icon"><use xlink:href="#icon-chev-left"></use></svg><span>' + parentMenuItemText + '</span></div><a class="go-category w-auto p-0 d-flex align-items-center" href="' + $this.data('href') + '"><span>' + currentMenuItemText + '</span><svg class="svg-icon"><use xlink:href="#icon-arrow-right-small"></use></svg></a></div>');
				$parentMenuItem.parent().append(subMenuHtml);
				$parentMenuItem.parent().addClass('submenu-active');
			}
		});

		$(document).on('click', '.close-submenu', function (e) {
			var $parent = $(this).parent();

			$parent.next('.dropdown-menu').remove();
			$parent.parent().removeClass('submenu-active');
			$parent.remove();
		});

	}

}

export default MegaMenuImages;
